import { observer } from 'mobx-react-lite';
import { useCallback, useEffect } from 'react';

import { useStores } from 'src/components/common/root-store-provider/root-store-provider';
import SelectOption, {
  OptionVariants,
} from 'src/components/main/quiz/select-option/select-option';
import { Policy } from 'src/widgets/policy';

import { fbAnalytics } from '@features/Analytics';
import { tikTokEvent } from '@features/Analytics/services/tik-tok-pixel';

import { Image } from '../../../common/Image';
import styles from './welcome-screen.module.scss';

const BUTTONS_TEXT = [
  {
    value: 0,
    label: 'I want to understand it better',
  },
  {
    value: 1,
    label: 'I want to explore compatibility',
  },
  {
    value: 2,
    label: 'I want to find a partner',
  },
  {
    value: 3,
    label: 'I have another question',
  },
];

const STARS = Array.from({ length: 10 }, (_, index) => (
  <span key={index} className={styles.star}></span>
));
export const WelcomeScreen = observer(
  ({ onChange }: { onChange: (value: number) => void }) => {
    // @ts-ignore
    const fbLoaded = window.fbq !== undefined;
    // @ts-ignore
    const tikTokLoaded = window.ttq !== undefined;

    const {
      quizStore: { welcome, setWelcome },
    } = useStores();
    const handleClick = useCallback(
      (value: number) => {
        setWelcome(value);
        onChange(value);
      },
      [onChange, setWelcome],
    );

    useEffect(() => {
      if (fbLoaded) {
        fbAnalytics({
          eventName: 'ViewContent',
          postPath: 'event_start_onboard',
        });
      }
    }, [fbLoaded]);

    useEffect(() => {
      if (tikTokLoaded) {
        tikTokEvent('ViewContent');
      }
    }, [tikTokLoaded]);
    return (
      <div className={styles.container}>
        <header>
          <Image src="logo.webp" width={40} height={40} alt="logo" priority />
          <div>
            <h3>Eclipse</h3>
            <p>Personal moon phases calendar</p>
          </div>
        </header>
        <section className={styles.mainSection}>
          <p className={styles.title}>Ask your relationship question</p>
          <div className={styles.optionsContainer}>
            {BUTTONS_TEXT.map(({ value: anotherValue, label }) => (
              <SelectOption
                key={`welcome_screen_${anotherValue}`}
                onChange={() => handleClick(anotherValue)}
                optionVariant={
                  welcome != null && anotherValue === welcome
                    ? OptionVariants.OptionSelected
                    : OptionVariants.OptionNotSelected
                }
                optionShapeType="noBorder"
                label={label}
              />
            ))}
          </div>
        </section>
        <footer>
          <Policy className={styles.policy} place="burger_menu" />
        </footer>
        <Image
          priority
          src="moon.webp"
          width={446}
          height={446}
          alt=""
          className={styles.moon}
        />
        <section>{STARS}</section>
      </div>
    );
  },
);
